(function () {
  var formId = 'WddJAE';
  var storageKey = 'firstcorner:welcome-popup:' + formId;
  var openDelay = 800;
  var visibleCheckLimit = 8000;
  var visibleCheckInterval = 250;
  var startedAt = Date.now();
  var shouldAutoOpen = true;
  var openRequested = false;

  if (window.Shopify && window.Shopify.designMode) return;

  try {
    if (window.sessionStorage.getItem(storageKey)) shouldAutoOpen = false;
  } catch (error) {
    // Continue when storage is unavailable.
  }

  function updateDiscountCopy(root) {
    var scope = root || document.body;
    if (!scope) return;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node = walker.nextNode();

    while (node) {
      if (/Get\s+15%\s+Off|15%\s+Off/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue
          .replace(/Get\s+15%\s+Off/g, 'Get 10% Off')
          .replace(/15%\s+Off/g, '10% Off');
      }

      node = walker.nextNode();
    }
  }

  function watchDiscountCopy() {
    updateDiscountCopy(document.body);

    if (!window.MutationObserver || !document.documentElement) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          updateDiscountCopy(mutation.target.parentNode);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) updateDiscountCopy(node);
          if (node.nodeType === 3 && /15%\s+Off/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/15%\s+Off/g, '10% Off');
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function rememberShown() {
    try {
      window.sessionStorage.setItem(storageKey, 'shown');
    } catch (error) {
      // Storage can be blocked in private modes; the popup can still open.
    }
  }

  function isVisible(element) {
    if (!element) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

    var rect = element.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20;
  }

  function hasKlaviyoFormVisible() {
    var forms = document.querySelectorAll('.klaviyo-form, [class*="klaviyo-form"]');

    return Array.prototype.some.call(forms, function (form) {
      return isVisible(form);
    });
  }

  function markShownWhenVisible(deadline) {
    if (hasKlaviyoFormVisible()) {
      openRequested = false;
      rememberShown();
      return;
    }

    if (Date.now() < deadline) {
      window.setTimeout(function () {
        markShownWhenVisible(deadline);
      }, visibleCheckInterval);
      return;
    }

    openRequested = false;
  }

  function requestWelcomePopup(source) {
    if (hasKlaviyoFormVisible()) {
      rememberShown();
      return;
    }

    if (openRequested) return;

    openRequested = true;
    document.documentElement.setAttribute('data-firstcorner-popup-trigger', source || 'manual');

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

    markShownWhenVisible(Date.now() + visibleCheckLimit);
  }

  function scheduleAutoOpen() {
    if (!shouldAutoOpen) return;

    var elapsed = Date.now() - startedAt;
    var delay = Math.max(0, openDelay - elapsed);

    window.setTimeout(function () {
      requestWelcomePopup('page-load');
    }, delay);
  }

  function bindExitIntent() {
    document.addEventListener('mouseleave', function (event) {
      if (event.clientY <= 0) requestWelcomePopup('exit-intent');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchDiscountCopy();
      bindExitIntent();
      scheduleAutoOpen();
    }, { once: true });
  } else {
    watchDiscountCopy();
    bindExitIntent();
    scheduleAutoOpen();
  }
})();
